import './LoginPage.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button } from '@mui/material';
import { useLocation } from "react-router-dom";
import { Alert } from "@mui/material";
import { getApiUrlFromBase } from '../../config/apiConfig';
import logoFull from '../../assets/logo-full.png';

const LoginPage = () => {
  const handleGoogleLogin = () => {
    const frontendRedirect = window.location.origin;
    const loginUrl = getApiUrlFromBase('api/auth/google');

    if (!loginUrl) {
      alert("Error: falta configurar REACT_APP_API_BASE_URL o una variable legacy de API.");
      return;
    }

    window.location.href = `${loginUrl}?redirect_uri=${encodeURIComponent(frontendRedirect)}`;
  };

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const error = params.get("error");
  const auth = params.get("auth");

  const authMessageByCode = {
    TOKEN_EXPIRED: 'Tu sesión expiró. Iniciá sesión nuevamente para continuar.',
    USER_INVALID: 'Tu sesión ya no es válida. Puede que tu usuario haya sido deshabilitado o que tus permisos hayan cambiado.',
    TOKEN_INVALID: 'No se pudo validar tu sesión actual. Iniciá sesión nuevamente.',
    TOKEN_MISSING: 'Tu sesión no está activa. Iniciá sesión para continuar.',
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="branding">
          <img src={logoFull} alt="Time Planner" className="branding-logo" />
          <p>Organizá tu equipo de forma simple y visual.</p>
          <ul>
            <li><CheckCircleIcon style={{ color: '#00E875', marginRight: 8 }} /> Licencias y turnos rotativos</li>
            <li><CheckCircleIcon style={{ color: '#00E875', marginRight: 8 }} /> Planificación por estación</li>
            <li><CheckCircleIcon style={{ color: '#00E875', marginRight: 8 }} /> Control de asistencia</li>
          </ul>
        </div>
      </div>

      <div className="login-right">
        <div className="login-box">
          <h2>Iniciar sesión</h2>
          {error === "unauthorized" && (
          <Alert severity="error" sx={{ mb: 2 }}>
            Acceso no autorizado. Tu usuario no está registrado.<br />
            Si necesitás acceso, contactá al administrador.
          </Alert>
)}
          {!error && auth && authMessageByCode[auth] && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              {authMessageByCode[auth]}
            </Alert>
          )}
          <Button
            variant="contained"
            color="primary"
            onClick={handleGoogleLogin}
            size="large"
            style={{ marginTop: 16 }}
          >
            Iniciar sesión con Google
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
